/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ movement: NonNullable<unknown> }} Prescription_Notice_Exercise_RepeatedInputs */

const en_us2_prescription_notice_exercise_repeated = /** @type {(inputs: Prescription_Notice_Exercise_RepeatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`One ${i?.movement} exercise appears on more than one day: there is no other you can do.`)
};

const pt_br2_prescription_notice_exercise_repeated = /** @type {(inputs: Prescription_Notice_Exercise_RepeatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Um exercício de ${i?.movement} aparece em mais de um dia: não há outro que você possa fazer.`)
};

const es_419_prescription_notice_exercise_repeated = /** @type {(inputs: Prescription_Notice_Exercise_RepeatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Un ejercicio de ${i?.movement} aparece en más de un día: no hay otro que puedas hacer.`)
};

const pt_pt2_prescription_notice_exercise_repeated = /** @type {(inputs: Prescription_Notice_Exercise_RepeatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Um exercício de ${i?.movement} aparece em mais de um dia: não há outro que possas fazer.`)
};

const fr_fr2_prescription_notice_exercise_repeated = /** @type {(inputs: Prescription_Notice_Exercise_RepeatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Un exercice « ${i?.movement} » apparaît sur plusieurs jours : il n'y en a pas d'autre que tu puisses faire.`)
};

const de_de2_prescription_notice_exercise_repeated = /** @type {(inputs: Prescription_Notice_Exercise_RepeatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Eine Übung für ${i?.movement} kommt an mehr als einem Tag vor: Es gibt keine andere, die du machen kannst.`)
};

const it_it2_prescription_notice_exercise_repeated = /** @type {(inputs: Prescription_Notice_Exercise_RepeatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Un esercizio di ${i?.movement} compare in più di un giorno: non ce n'è un altro che puoi fare.`)
};

/**
* | output |
* | --- |
* | "One {movement} exercise appears on more than one day: there is no other you can do." |
*
* @param {Prescription_Notice_Exercise_RepeatedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const prescription_notice_exercise_repeated = /** @type {((inputs: Prescription_Notice_Exercise_RepeatedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prescription_Notice_Exercise_RepeatedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_prescription_notice_exercise_repeated(inputs)
	if (locale === "es-419") return es_419_prescription_notice_exercise_repeated(inputs)
	if (locale === "pt-PT") return pt_pt2_prescription_notice_exercise_repeated(inputs)
	if (locale === "fr-FR") return fr_fr2_prescription_notice_exercise_repeated(inputs)
	if (locale === "de-DE") return de_de2_prescription_notice_exercise_repeated(inputs)
	if (locale === "it-IT") return it_it2_prescription_notice_exercise_repeated(inputs)
	return en_us2_prescription_notice_exercise_repeated(inputs)
});
export { prescription_notice_exercise_repeated as "prescription.notice.exercise_repeated" }